import React from 'react'
// import { Container } from 'react-bootstrap';
import ImageCart from '../Components/ImageCart';

export default function ChardhamTemple() {
  return (
    <>
     <div>
            <h2 style={{ display: "flex", justifyContent:"center", marginTop: "50px", marginBottom: "30px", textTransform: "uppercase", wordSpacing: "3.5px"  }}>Temples Of Chardham</h2>
            <ImageCart />
        </div> 
    </>
  )
}
